import app from "lib/app";
import me from "models/me";
import siteConfig from "site-config";
import fetch from "lib/fetch";
import get from "lodash/get";
import { getStore } from "store";
import { activeBrandSet, toggleHideMsrp, toggleHideWholesale } from "actions/scope";
import { cartFetch } from "actions/cart";
import { fetchSchemas } from "actions/schemas";
import validators from "lib/validators";
import redirectOnLogin from "helpers/redirectOnLogin";
import { parse } from "query-string";

export default function (nextState, replace, callback) {
    const brandId = nextState.params.brand || parse(location.search || "").brand;
    if (me.isSignedIn() && (!brandId || !validators.objectId(brandId))) {
        me.unset("last_brand");
        redirectOnLogin({ replace, location: nextState.location });
        callback();
    } else if (me.isSignedIn()) {
        // Either grab it from cache or the server
        app.brands.getOrFetch(brandId, { handle401: true }, (err, model) => {
            if (err) {
                me.unset("last_brand");
                redirectOnLogin({ replace, location: nextState.location });
                callback();
            } else {
                if (
                    me.account_type === "nuorder" &&
                    !model.active &&
                    nextState.location.pathname.indexOf(`brand/${model._id}/management`) === -1
                ) {
                    replace({ pathname: `/brand/${model._id}/management` });
                    callback();
                    return;
                }
                const activeBrand = model.toJSON();
                const store = getStore();
                store.dispatch(fetchSchemas(model._id)).then(() => {
                    if (model.has_profile === undefined) {
                        fetch(`${siteConfig.goAPI}/v1/pages/brand/${model._id}`, { brandId: activeBrand._id })
                            .then((response) => {
                                if (response.status >= 300) {
                                    throw new Error("Not found");
                                }
                                return response.json();
                            })
                            .then((data) => {
                                activeBrand.has_profile = get(data, "data[0].published", false);
                                store.dispatch(activeBrandSet(activeBrand));
                                if (!me.isGuestBuyer()) {
                                    store.dispatch(cartFetch());
                                }
                            })
                            .catch(() => {
                                activeBrand.has_profile = false;
                                store.dispatch(activeBrandSet(activeBrand));
                                if (!me.isGuestBuyer()) {
                                    store.dispatch(cartFetch());
                                }
                            })
                            .then(() => {
                                store.dispatch(toggleHideMsrp(!!me.getViewPref("hide_product_price_msrp")));
                                store.dispatch(toggleHideWholesale(!!me.getViewPref("hide_product_price_wholesale")));

                                callback();
                            });
                    } else {
                        process.nextTick(function () {
                            callback();
                        });
                    }
                });
            }
        });
    } else {
        me.unset("last_brand");
        replace({ pathname: "/login" });
        callback();
    }
}
